import {FieldKind} from "./object-reflection";
import {FormFieldConfig} from "../model/api/form-field-config";
import TYPE = FormFieldConfig.TYPE;
import {FormFieldGroupConfig} from "../model/api/form-field-group-config";
import {DateFormatPipe} from "./date-format.pipe";

export function mapFieldKindToFormType(kind: FieldKind): TYPE {
  switch (kind) {
    case 'number':
      return TYPE.INTEGER;
    case 'boolean':
      return TYPE.CHECKBOX;
    case 'date':
      return TYPE.DATE;
    case 'datetime':
      return TYPE.DATETIME;
    case 'enum':
      return TYPE.DROPDOWN;
    case 'array':
      return TYPE.TABLEFORMFIELD;
    default:
      return TYPE.TEXT;
  }
}

export function buildFormField<T>(
  field: keyof T,
  kind: FieldKind,
  column = 3
): FormFieldConfig {
  return {
    field: field as string,
    label: field as string,
    column,
    type: mapFieldKindToFormType(kind)
  };
}

export function PrepareFormDateFields(
  formRecord: {},
  formConfig: FormFieldGroupConfig[]
) {
  if (formRecord) {
    formConfig.forEach((fieldGroupConfig: FormFieldGroupConfig) => {
      fieldGroupConfig.fields.forEach(fieldConfig => {
        if (formRecord[fieldConfig.field]
          && (fieldConfig.type == TYPE.DATE || fieldConfig.type == TYPE.DATETIME)) {
          formRecord[fieldConfig.field] = new Date(formRecord[fieldConfig.field]);
        }
      });
    })
  }
}

export function PrepareForSaveDateFields(
  formRecord: {},
  formConfig: FormFieldGroupConfig[]
) {
  if (formRecord) {
    formConfig.forEach((fieldGroupConfig: FormFieldGroupConfig) => {
      fieldGroupConfig.fields.forEach(fieldConfig => {
        if (formRecord[fieldConfig.field]
          && (fieldConfig.type == TYPE.DATE || fieldConfig.type == TYPE.DATETIME)) {
          DateFormatPipe.checkDate(formRecord, fieldConfig.field);
        }
      });
    })
  }
}
